// extracted by mini-css-extract-plugin
module.exports = {"container":"Modal_container__SAczP","modal":"Modal_modal__PoGhq","close-container":"Modal_close-container__7uGoq","backdrop":"Modal_backdrop__6qaKe"};